import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "priceshow__contact-widget" }
const _hoisted_2 = { class: "m-0" }
const _hoisted_3 = {
  href: "tel:+498001332331",
  target: "_blank"
}

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faPhone } from '@fortawesome/pro-solid-svg-icons';


export default /*@__PURE__*/_defineComponent({
  __name: 'PriceshowContactWidget',
  setup(__props) {

library.add(faPhone);

return (_ctx: any,_cache: any) => {
  const _component_BaseSpacer = _resolveComponent("BaseSpacer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("h6", null, " Kannst Du Dich nicht entscheiden oder hast Du eine Frage? ", -1)),
    _createVNode(_component_BaseSpacer),
    _createElementVNode("p", _hoisted_2, [
      _cache[1] || (_cache[1] = _createTextVNode(" Wir sind gern für Dich da:", -1)),
      _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("a", _hoisted_3, [
        _createVNode(_unref(FontAwesomeIcon), { icon: "fa-solid fa-phone" }),
        _cache[0] || (_cache[0] = _createTextVNode(" 0800 133 233 1 ", -1))
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
      _cache[4] || (_cache[4] = _createElementVNode("small", null, " (Mo.-Fr. 07-19 Uhr, Sa. 08-16 Uhr) ", -1))
    ])
  ]))
}
}

})